var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgArrowRight = function SvgArrowRight(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.12 9.91 19.25 6a1 1 0 1 0-1.42 1.41L21.39 11H1a1 1 0 0 0 0 2h20.45l-3.62 3.61a1.002 1.002 0 0 0 .325 1.639 1 1 0 0 0 1.095-.219l3.87-3.88a3 3 0 0 0 0-4.24"
  })));
};
export default SvgArrowRight;